import { Observable } from "rxjs";
import { DeviceObject } from "./models/device-object.model";
import { ParkingLotMap } from "./models/parking-lot-map.model";
import { ParkingLot } from "./models/parking-lot.model";

export abstract class ParkingLotBase {
    abstract fetchParkingLotMap(parkingLotId: number): Observable<ParkingLotMap>;
    abstract fetchParkingLots(amountOfRetries: number): Observable<Array<ParkingLot>>;
}